// Reviews linkine tıklayınca tab aç ve kaydır
document.addEventListener('DOMContentLoaded', function() {
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabPanes = document.querySelectorAll('.tab-pane');

    // Tab switching
    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            const tabName = this.getAttribute('data-tab');

            tabButtons.forEach(btn => {
                btn.classList.remove('active');
                btn.classList.remove('border-primary-500');
                btn.classList.add('border-transparent');
            });
            tabPanes.forEach(pane => pane.classList.remove('active'));

            this.classList.add('active');
            this.classList.remove('border-transparent');
            this.classList.add('border-primary-500');
            document.getElementById(tabName).classList.add('active');
        });
    });

    // Goto reviews link
    const gotoReviews = document.getElementById('goto-reviews');
    if (gotoReviews) {
        gotoReviews.addEventListener('click', function(e) {
            e.preventDefault();

            tabButtons.forEach(btn => {
                btn.classList.remove('active', 'border-primary-500');
                btn.classList.add('border-transparent');
            });
            tabPanes.forEach(pane => pane.classList.remove('active'));

            const reviewsBtn = document.querySelector('[data-tab="reviews"]');
            const reviewsPane = document.getElementById('reviews');

            reviewsBtn.classList.add('active', 'border-primary-500');
            reviewsBtn.classList.remove('border-transparent');
            reviewsPane.classList.add('active');

            const header = document.getElementById('header');
            const headerHeight = header ? header.offsetHeight : 0;
            const reviewsBtnTop = reviewsBtn.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top: reviewsBtnTop - headerHeight - 16,
                behavior: 'smooth'
            });
        });
    }
});